<script setup lang="ts">
const props = defineProps<{
  profileSections: {
    key: string
    title: string
    icon: string
    url: string
  }[]
}>()

const site = useSite()
const authStore = useAuthStore()
const appStore = useAppStore()
const { t } = useLocale()
const { ssoRoute } = useMcdRoutes()
const { trackProfileMenuClick } = useGTM()

const sideBarSections = site?.sideBar?.sections

const onRouteClick = (menuItem: string) => {
  trackProfileMenuClick(menuItem)
}
</script>

<template>
  <main class="flex h-full w-full justify-center px-4">
    <section class="mt-14 flex w-96 flex-col gap-5">
      <template v-if="authStore.isUserLogged">
        <UserQRCard />

        <div class="flex h-[40vh] flex-col gap-5 py-5">
          <section v-for="section in props.profileSections" :key="section.key">
            <NuxtLink :to="section.url" @click="onRouteClick(section.key)">
              <section class="mb-2 flex w-full items-center gap-5">
                <figure>
                  <img class="h-full w-6" :src="section.icon" :alt="section.title" />
                </figure>
                <h4 class="text-sm">{{ section.title }}</h4>
                <figure class="flex flex-grow justify-end">
                  <img class="h-full w-6" src="/images/icons/arrowForward.svg" alt="navigate" />
                </figure>
              </section>
            </NuxtLink>
          </section>
        </div>
      </template>

      <template v-else>
        <div>
          <h1 v-dompurify-html="t('profile.notLogged.title')" class="mb-6 text-2xl"></h1>
          <template v-if="!appStore.isEcommerceDisabled">
            <p class="mb-5 text-sm">{{ t('profile.notLogged.subtitle') }}</p>

            <div class="flex flex-row items-center gap-4">
              <NuxtLink
                class="btn-secondary w-full py-3 text-center text-sm"
                :to="ssoRoute({ register: false })"
                external
              >
                {{ t('auth.login') }}
              </NuxtLink>

              <NuxtLink
                class="btn-primary w-full py-3 text-center text-sm"
                :to="ssoRoute({ register: true })"
                external
              >
                {{ t('auth.register') }}
              </NuxtLink>
            </div>
          </template>
        </div>
      </template>

      <div>
        <template v-for="link of sideBarSections" :key="link.name">
          <LinkList :title="link.name" :links="link.links" />
        </template>
      </div>
    </section>
  </main>
</template>
